import { createSlice } from "@reduxjs/toolkit";
import { ArquivoAnexoModel } from "../../../models/arquivoAnexo/arquivoAnexoModel";
import { TipoArquivoAnexoModel } from "../../../models/arquivoAnexo/tipoArquivoAnexoModel";
import { listarArquivoAnexo, listarTipoArquivoAnexo } from "../../../services/arquivoAnexoService";
import { AnexoItemModel } from "../../../models/arquivoAnexo/anexoItemModel";
import { resetAll } from "../../actions/actions";

export interface ArquivoAnexoState {
  //buscar arquivo anexo
  loading: boolean;
  list: ArquivoAnexoModel[];
  //buscar tipo arquivo anexo
  loadingTipo: boolean;
  listTipo: TipoArquivoAnexoModel[];
  //internal
  dataSourceAnexo: AnexoItemModel[];
  editingKeyAnexo: string;
  listCount: number;
  modalArquivo: boolean;
  modalAnexo: boolean;
  modalDeletar: boolean;
}

const initialState: ArquivoAnexoState = {
  //buscar arquivo anexo
  loading: false,
  list: [],
  //buscar tipo arquivo anexo
  loadingTipo: false,
  listTipo: [],
  //internal
  dataSourceAnexo: [],
  editingKeyAnexo: "",
  listCount: 0,
  modalArquivo: false,
  modalAnexo: false,
  modalDeletar: false,
};

export const arquivoAnexoSlice = createSlice({
  name: "arquivoAnexo",
  initialState,
  reducers: {
    //internal
    resetArquivoAnexo: (state) => {
      state.loading = false;
      state.list = [];
      state.listTipo = [];
      state.dataSourceAnexo = [];
      state.editingKeyAnexo = "";
      state.modalArquivo = false;
    },
    setDataSourceAnexo: (state, action) => {
      state.dataSourceAnexo = action.payload;
    },
    setEditingKeyAnexo: (state, action) => {
      state.editingKeyAnexo = action.payload;
    },
    setModalArquivo: (state, action) => {
      state.modalArquivo = action.payload;
    },
    setModalAnexo: (state, action) => {
      state.modalAnexo = action.payload;
    },
    setModalDeletarArquivoAnexo: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar arquivo anexo
    builder.addCase(listarArquivoAnexo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarArquivoAnexo.fulfilled, (state, action) => {
      state.list = action.payload;
      state.listCount = action.payload.length;
      state.loading = false;
    });
    builder.addCase(listarArquivoAnexo.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar tipo arquivo anexo
    builder.addCase(listarTipoArquivoAnexo.pending, (state) => {
      state.loadingTipo = true;
    });
    builder.addCase(listarTipoArquivoAnexo.fulfilled, (state, action) => {
      state.listTipo = action.payload;
      state.loadingTipo = false;
    });
    builder.addCase(listarTipoArquivoAnexo.rejected, (state, action) => {
      state.loadingTipo = false;
    });
  },
});

export const {
  //internal
  resetArquivoAnexo,
  setModalArquivo,
  setDataSourceAnexo,
  setEditingKeyAnexo,
  setModalAnexo,
  setModalDeletarArquivoAnexo,
} = arquivoAnexoSlice.actions;

export default arquivoAnexoSlice.reducer;
